import { render, staticRenderFns } from "./SAcheivements.vue?vue&type=template&id=5125ea2c&scoped=true&"
import script from "./SAcheivements.vue?vue&type=script&lang=js&"
export * from "./SAcheivements.vue?vue&type=script&lang=js&"
import style0 from "./SAcheivements.vue?vue&type=style&index=0&id=5125ea2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5125ea2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VLayout})
